import React from 'react';
import slide1 from './imagenes/1.jpeg';
import slide2 from './imagenes/2.jpeg';
import slide3 from './imagenes/3.jpeg';
import slide4 from './imagenes/4.jpeg';
import slide5 from './imagenes/5.jpeg';
import slide6 from './imagenes/6.jpeg';
import './carousel.css';

const images = [slide1, slide2, slide3, slide4, slide5, slide6];

const Carousel = () => {
  return (
    <div
      id="carouselExampleCaptions"
      className="carousel slide carousel-fade"
      data-bs-ride="carousel"
      data-bs-interval="5000"
    >
      <div className="carousel-indicators">
        {images.map((_, i) => (
          <button
            key={i}
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to={i}
            className={i === 0 ? "active" : ""}
            aria-current={i === 0 ? "true" : undefined}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>
      <div className="carousel-inner">
        {images.map((img, idx) => (
          <div
            key={idx}
            className={idx === 0 ? "carousel-item active" : "carousel-item"}
          >
            <img
              src={img}
              className="d-block w-100"
              alt={`Slide ${idx + 1}`}
            />
          </div>
        ))}
      </div>
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleCaptions"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Anterior</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleCaptions"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Siguiente</span>
      </button>
    </div>
  );
};

export default Carousel;